import Timer from "../common/Timer";
import { TEXT_BADGE } from "../../style";

export default function Summary({ test, showResult }) {
    return (
        <div className="self-test-summary flex align-items-center justify-content-center gap-3 py-2 border-round-xl">
            <Timer minutes={test.timerMinute} onTimeUp={showResult} />
            <div className="flex flex-column gap-2">
                <span
                    className={`text-center ${TEXT_BADGE} bg-green-500 text-white font-bold p-2 border-round border-1 border-green-300 scalein animation-duration-500 animation-iteration-1`}
                    key={test?.correctAnswers}
                >
                    Score : {test?.correctAnswers}
                </span>
                <span
                    className={`text-center ${TEXT_BADGE} bg-yellow-400 text-bluegray-900 font-bold p-2 border-round border-1 border-yellow-200 scalein animation-duration-500 animation-iteration-1`}
                >
                    Question : {test?.currentQuestion + 1}/{test?.questions?.length}
                </span>
            </div>
        </div>
    );
}
